<template>
  <div id="app" class="lxn-w100" :style="fullHeightStyle">
    <router-view/>
    <LoadingSpinner v-if="$store.state.appBusy">
    </LoadingSpinner>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import FastClick from 'fastclick';
// import Vue from 'vue'

window.addEventListener('load', () => {
  FastClick.attach(document.body);
}, false);

//  Vue.config.errorHandler = function (err, vm, info) {
//    alert(err);
//    alert(JSON.stringify(err));
//    alert(info);
//  }
//  window.onerror = function(message, source, line, column, error) {
//    alert(message);
//    alert(source);
//    alert(line);
//    alert(column);
//    alert(error);
// }

export default {
  name: 'App',
  components: {
    LoadingSpinner
  },
  data: function() {
    return {
      fullHeight: '100%',
    }
  },
  mounted: function () {
    // window.addEventListener('resize', this.handleResize);
    // this.handleResize();
  },
  destroyed: function () {
    // window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    fullHeightStyle: function () {
      var fullHeightStyle = 'height: ' + this.fullHeight + ';';
      return fullHeightStyle;
    }
  },
  methods: {
    // handleResize: function () {
    //   var fullHeight = window.innerHeight;
    //   this.fullHeight = fullHeight + 'px';
    // }
  }
}
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* background-color: #FFFFFF; */
    background-color: #EEEEEE;
    min-width: 300px;
    min-height: 450px;
  }
</style>
